// Email 2FA step 2 (backend two_fa_routes.py). A login that needs an emailed
// code returns only a short-lived pre_token: /send emails the code to that
// account and /verify swaps the pre_token + code for the real login token.
const API_URL = process.env.REACT_APP_BACKEND_URL;

// Matches the server's resend cooldown (otp_store.RESEND_COOLDOWN_SECONDS).
export const RESEND_COOLDOWN_SECONDS = 30;

const post = async (path, body) => {
  const res = await fetch(`${API_URL}/api/auth/2fa/${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const message = typeof data.detail === 'string' ? data.detail : 'Request failed';
    throw Object.assign(new Error(message), { status: res.status, body: data });
  }
  return data;
};

/** Email (or re-email) the code. Returns { message }. */
export const sendEmailCode = (preToken) => post('send', { pre_token: preToken });

/** Check the code. Returns { access_token, user }. */
export const verifyEmailCode = (preToken, code) => post('verify', { pre_token: preToken, code });
